<template>
  <v-select
    :items="destinations"
    :label="$t('productsImport.selectDestination')"
    :rules="[(v) => !!v || $t('productsImport.selectDestination')]"
    :item-text="(v) => v.getName()"
    :item-value="selectedDestination ? selectedDestination.getSlug() : null"
    return-object
    outlined
    @change="
      (v) => {
        this.$emit('update:selectedDestination', v)
      }
    "
  />
</template>

<script>
export default {
  name: 'DestinationSelector',
  props: {
    selectedDestination: {
      type: Object,
      required: false,
      default: null,
    },
    permission: {
      type: String,
      required: true,
    },
  },
  computed: {
    destinations() {
      const userInstance = this.$store.getters.getAppUserInstance()
      return userInstance
        .getUserDestinationsInstance()
        .getDestinationsWithPermissions(this.permission)
    },
  },
}
</script>
